import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';

import Config from '../../../config';

import { fetchConnections as fetchConnectionsApi } from '../../../shared/api';
import getApi from '../../shared/apiFactory';

import agGridConfig from '../../../agGridConfig';
import {
  SELECT_CONNECTION_FOR_TRIAL_BALANCE_THRESHOLD,
  FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD,
  FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_SUCCESS,
  FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_FAILURE,
} from './types';

import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';
import columnHeaders from '../xlsxImport/columnHeaders';
import { FIELD_MAPPINGS, MIN_COLUMNS_NUMBER, MAX_COLUMNS_NUMBER } from '../xlsxImport/constants';
import { connectionNameSelector } from './selectors';

export const sharedActions = getActions(
  adminPageNames.TRIAL_BALANCE_THRESHOLD,
  {
    pageTitle: adminPageTitles.TRIAL_BALANCE_THRESHOLD,
    api: getApi({
      pageTitle: adminPageTitles.TRIAL_BALANCE_THRESHOLD,
      endpoints: {
        FETCH: Config.endpoints.FETCH_TRIAL_BALANCE_THRESHOLD,
        UPDATE: Config.endpoints.UPDATE_TRIAL_BALANCE_THRESHOLD,
        VALIDATE: Config.endpoints.VALIDATE_TRIAL_BALANCE_THRESHOLD,
        IMPORT: Config.endpoints.IMPORT_TRIAL_BALANCE_THRESHOLD,
      },
    }),
    sortingField: 'functionalCurrency',
    agGridConfig: agGridConfig.adminTrialBalanceThreshold,
    excel: {
      sheetName: 'Trial Balance Out of Balance Th',
      lastColumnLetter: 'B',
      columnHeaders,
      fieldMappings: FIELD_MAPPINGS,
      minColumnsNumber: MIN_COLUMNS_NUMBER,
      maxColumnsNumber: MAX_COLUMNS_NUMBER,
    },
  }
);

export const fetchConnections = periodName => async (dispatch, getState) => {
  dispatch({
    type: FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD,
  });
  const currentConnectionName = connectionNameSelector(getState());

  try {
    const response = await fetchConnectionsApi({ period: periodName });
    const connection = response.find(({ connName }) => connName === currentConnectionName);

    return dispatch({
      type: FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_SUCCESS,
      connectionNames: response.map(({ connName }) => ({ value: connName, label: connName })),
      connectionName: connection ? connection.connName : null,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};


export const selectConnection = connectionName => async dispatch => {
  dispatch({
    type: SELECT_CONNECTION_FOR_TRIAL_BALANCE_THRESHOLD,
    connectionName,
  });
};
